export default __webpack_public_path__ + "static/media/whats.31020798.svg";